import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from '@sketchpixy/rubix'
import { browserHistory } from 'react-router'
import styles from './styles'
import { convertOrderTypeToUrl, redirectUrlsAfterPaymentSuccess } from './helpers'

import { flattenArray, getErrors, promised } from '../../../../helpers/utility'
import * as actionsTypes from '../../../../actions/actions'
import withLoading from '../../withLoadingHOC/withLoadingHOC'
import OrderInvoice from './OrderInvoice'
import { compose } from 'recompose'
import Loading from '../../Loading/Loading'

class PaymentSuccess extends Component {
  constructor(props) {
    super(props)
    this.state = {
      orderData: null,
      message: '',
      errors: [],
    }
  }

  componentDidMount = () => {
    this.checkPaymentStatus()
  }

  checkPaymentStatus = () => {
    promised(this.props.fetchOrderData, this.props.params.orderId)
      .then(this.onOrderDataFetchSuccess)
      .catch(this.onOrderDataFetchFailure)
  }

  onOrderDataFetchSuccess = orderData => {
    this.setState(
      {
        orderData,
        message: 'خرید شما با موفقیت به پایان رسید.',
      },
      this.props.loading.onLoadingEnd
    )
  }

  onOrderDataFetchFailure = ({ form_errors, general_errors }) => {
    const flattenedErrors = [...flattenArray(general_errors), ...getErrors(form_errors)]

    this.setState(
      {
        message: 'پرداخت موفقیت آمیز نبود. در حال بازگشت ...',
        errors: flattenedErrors,
        hasError: true,
      },
      this.props.loading.onLoadingEnd
    )
  }

  renderErrors = errorsArray =>
    errorsArray.length === 0 ? null : (
      <section style={styles.base}>
        {errorsArray.map((error, i) => (
          <div key={i} className="form-error">
            {error}
          </div>
        ))}
      </section>
    )

  redirect = ({ service: { type: serviceType } = {} }) => DOMEvent => {
    DOMEvent.stopPropagation()

    if (!(serviceType in redirectUrlsAfterPaymentSuccess)) {
      const errMsg = `service type ${serviceType} is not defined in ${redirectUrlsAfterPaymentSuccess}`
      throw new Error(errMsg)
    }

    browserHistory.push(redirectUrlsAfterPaymentSuccess[serviceType])
  }

  render() {
    const { message, errors } = this.state

    if (this.props.loading.isLoading) return <Loading />

    return (
      <section style={styles.wrapper}>
        <h5 style={this.state.hasError ? styles.error : styles.success}>{message}</h5>

        {this.renderErrors(errors)}

        <OrderInvoice order={this.state.orderData} userType={this.props.userType} />

        <Button
          onClick={this.redirect(this.state.orderData)}
          bsStyle="primary"
          style={{ justifySelf: 'start' }}
        >
          بازگشت
        </Button>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  userType: state.auth.userType,
})

const actions = {
  fetchOrderData: (orderId, { resolve, reject }) => ({
    type: actionsTypes.FETCH_SINGLE_ORDER_REQUEST,
    orderId,
    resolve,
    reject,
  }),
}

const HOC = compose(
  withLoading({ initialLoading: true }),
  connect(
    mapStateToProps,
    actions
  )
)

export default HOC(PaymentSuccess)



// WEBPACK FOOTER //
// ./src/components/common/credit/PaymentSuccess/PaymentSuccess.js